import React from 'react';
import { Layout } from './shared';


const tiers = [
  {
    name: 'Starter',
    price: '$0',
    period: '/month',
    features: [
      'Upload up to 20 pages',
      'Basic OCR and parsing',
      'Email support',
    ],
    cta: 'Get Started',
    highlight: false,
  },
  {
    name: 'Pro',
    price: '$199',
    period: '/month',
    features: [
      'Up to 5,000 pages/month',
      'AI cleaning & structuring',
      'Priority support',
      'Flexible exports (CSV/XLSX/JSON)',
    ],
    cta: 'Start Pro Trial',
    highlight: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    features: [
      'Unlimited volumes',
      'Dedicated validation & QA',
      'SLA, SSO, custom workflows',
      'On-prem or VPC options',
    ],
    cta: 'Contact Sales',
    highlight: false,
  },
];



const PricingPage = ({ openRequestModal }) => {
  return (
    <Layout openRequestModal={openRequestModal}>
      <section className="px-6 py-20 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Simple, transparent pricing</h1>
          <p className="text-lg text-gray-600 mb-12">Choose a plan that matches your volume and compliance needs.</p>

          <div className="grid md:grid-cols-3 gap-6">
            {tiers.map((tier) => (
              <div
                key={tier.name}
                className={`p-8 border rounded-2xl text-left ${tier.highlight ? 'border-blue-300 shadow-xl' : 'border-gray-200'}`}
              >
                <div className="flex items-baseline gap-2 mb-4">
                  <div className="text-3xl font-bold text-gray-900">{tier.price}</div>
                  <div className="text-gray-500">{tier.period}</div>
                </div>
                <div className="font-semibold text-gray-900 mb-4">{tier.name}</div>
                <ul className="space-y-2 mb-6">
                  {tier.features.map((f) => (
                    <li key={f} className="text-sm text-gray-600">{f}</li>
                  ))}
                </ul>
                <a
                  href={tier.name === 'Enterprise' ? 'mailto:connect@digitables.ai?subject=Enterprise%20Inquiry' : '#'}
                  className={`inline-flex justify-center w-full px-6 py-3 rounded-lg font-medium transition-colors ${
                    tier.highlight ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  {tier.cta}
                </a>
              </div>
            ))}
          </div>

          {/* FAQ */}
          <div className="mt-20 text-left max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Pricing FAQ</h2>
            <div className="space-y-6">
              <div>
                <div className="font-semibold text-gray-900">What if my tables are huge?</div>
                <p className="text-gray-600 text-sm">We handle large, complex tables routinely. For heavy volumes, talk to us about Enterprise.</p>
              </div>
              <div>
                <div className="font-semibold text-gray-900">Do you handle handwriting?</div>
                <p className="text-gray-600 text-sm">Yes, with human-in-the-loop validation. Typical accuracy depends on legibility — we can assess samples.</p>
              </div>
              <div>
                <div className="font-semibold text-gray-900">Can you support custom schemas?</div>
                <p className="text-gray-600 text-sm">Absolutely. We can map outputs to your schema and enforce data validations.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


    </Layout>
  );
};

export default PricingPage;


